export default __webpack_public_path__ + "images/cancerfondsrapporten/icon-drinks.png";